import React, { useState, useEffect } from "react";
import { Card, Breadcrumb, Col, Row, Accordion, FormControl, InputGroup, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import corner4 from "assets/img/illustrations/corner-4.png";
import Background from "components/common/background";
import { Link } from "react-router-dom";
import { useLocationRedirect } from "../../assets/js/common";
import ReactPlayer from 'react-player';
import { useTranslation } from "react-i18next";
import howToCreateLocationVideo from 'assets/video/support_videos/How_to_create_location.mp4';
import howToCreateLocationThumb from 'assets/img/support_video_thumbnails/How_to_create_location.png';
import howToCreateRelationVideo from 'assets/video/support_videos/How_to_create_relation.mp4';
import howToCreateRelationThumb from 'assets/img/support_video_thumbnails/How_to_create_relation.png';
import howToCreateUserVideo from 'assets/video/support_videos/How_to_create_user.mp4';
import howToCreateUserThumb from 'assets/img/support_video_thumbnails/How_to_create_user.png';
import { getDomainConfig } from "../../config/domainConfig";

const Faq = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentlyPlayingIndex, setCurrentlyPlayingIndex] = useState(null);
  useLocationRedirect("dashboard");
  const { t } = useTranslation();
  const orgName = process.env.REACT_APP_ORGANIZATION_NAME || 'GetPlan';
  const finLabels = getDomainConfig().financialLabels;

  const faqItems = [
    {
      question: t("faqBranchTitle"),
        answer: (
          <ul>
            <li><strong>{t("branchCreateTitle")}:</strong></li>
            <ul>
              <li>{t("locationCreateLogin", { organizationName: orgName })}</li>
              <li>{t("locationCreateGoToSettings")}</li>
              <li>{t("branchCreateClickNewBtn")}</li>
              <li>
                {t("locationCreateEnterRequiredFields")}
                <ul>
                  <li>{t(finLabels.locationRequiredFieldsKey)}</li>
                  <li>
                    {t("locationCreateOptionalFields")}:{" "}
                    {finLabels.locationOptionalFields(t)}
                  </li>
                </ul>
              </li>
              <li>{t("locationCreateClickSave")}</li>
              <li>{t("branchCreateSuccessMsg")}</li>
              <li>{t("branchCreateListTop")}</li>
            </ul>

            <li className="mt-3"><strong>{t("branchUpdateTitle")}:</strong></li>
            <ul>
              <li>{t("branchUpdateClickEditBtn")}</li>
              <li>
                {t("locationUpdateEditFields")}
                <ul>
                  <li>
                    {t("locationUpdateFields")}
                  </li>
                </ul>
              </li>
              <li>{t("locationUpdateClickSave")}</li>
              <li>{t("branchUpdateSuccessMsg")}</li>
            </ul>

            <li className="mt-3"><strong>{t("branchDeleteTitle")}:</strong></li>
            <ul>
              <li>{t("branchDeleteClickDeleteBtn")}</li>
              <li>
                {t("locationDeleteConfirmPopup")}
                <ul>
                  <li>{t("branchDeleteConfirmPopupMsg")}</li>
                  <li>{t("locationDeleteConfirmBtn")}</li>
                  <li>{t("branchDeleteSuccessMsg")}</li>
                  <li>{t("branchDeleteCancelBtn")}</li>
                </ul>
              </li>
            </ul>
          </ul>
        ),
      video: howToCreateLocationVideo,
      thumbnail: howToCreateLocationThumb
    },
    {
      question: t('faqRelationTitle'),
      answer: (
        <ul>
          <li><strong>{t("relationCreateTitle")}:</strong></li>
          <ul>
            <li>{t("relationCreateLogin", { organizationName: orgName })}</li>
            <li>{t("relationCreateGoToMenu")}</li>
            <li>{t("relationCreateSelectBranch")}</li>
            <li>{t("relationCreateClickNewBtn")}</li>
          </ul>

          <li className="mt-3"><strong>{t("relationCreateTypesAvailable")}</strong></li>

          <li className="mt-3"><strong>{t("relationCreateProspectTitle")}</strong></li>
            <ul>
              <li>{t("relationCreateProspectSelectType")}</li>
              <li>{t("relationCreateProspectEnterFields")}</li>
              <li>
                {t(finLabels.relationProspectOptionalKey)}
              </li>
              <li>{t("relationCreateProspectClickSave")}</li>
              <li>{t("relationCreateProspectSuccessMsg")}</li>
              <li>{t("relationCreateProspectListTop")}</li>
            </ul>

          {/* NL only — Client with Asperion */}
          {finLabels.showAsperionSection && (
            <>
              <li className="mt-3"><strong>{t("relationCreateClientTitle")}</strong></li>
              <ul>
                <li>{t("relationCreateClientSelectType")}</li>
                <li>{t("relationCreateClientToggleAsperion")}</li>
                <li>{t("relationCreateClientEnableToggle")}</li>
                <li>{t("relationCreateClientEnterFields")}</li>
                <li>{t("relationCreateClientOptionalFields")}</li>
                <li>{t("relationCreateClientClickSave")}</li>
                <li>{t("relationCreateClientSuccessAsperion")}
                  <ul>
                    <li>{t("relationCreateClientSuccessfullyDebtorCreated")}</li>
                    <li>{t("relationCreateClientRelationAdded")}</li>
                  </ul>
                </li>
                <li>{t("relationCreateClientListTop")}</li>
              </ul>

              <li className="mt-3"><strong>{t("relationCreateClientNoAsperionTitle")}</strong></li>
              <ul>
                <li>{t("relationCreateClientToggleOff")}</li>
                <li>{t("relationCreateClientAddFields")}
                  <ul>
                    <li>{t("relationCreateClientFields")}</li>
                    <li>{t("relationCreateClientOptionalFieldswithoutAsperion")}</li>
                  </ul>
                </li>
                <li>{t("relationCreateClientNoAsperionClickSave")}</li>
                <li>{t("relationCreateClientNoAsperionSuccessMsg")}</li>
                <li>{t("relationCreateClientNoAsperionNote")}</li>
              </ul>
            </>
          )}

          {/* IN only — Client without Asperion (simple create) */}
          {finLabels.showSimpleClientSection && (
            <>
              <li className="mt-3"><strong>{t("relationCreateClientTitle")}</strong></li>
              <ul>
                <li>{t("relationCreateClientSelectType")}</li>
                <li>{t("relationCreateClientAddFields")}
                  <ul>
                    <li>{t("relationCreateClientFields")}</li>
                    <li>
                      {t("relationCreateClientOptionalFieldsWithoutAsperionIN")} 
                    </li>
                  </ul>
                </li>
                <li>{t("relationCreateClientNoAsperionClickSave")}</li>
                <li>{t("relationCreateClientNoAsperionSuccessMsg")}</li>
              </ul>
            </>
          )}

          <li className="mt-3"><strong>{t("relationUpdateTitle")}:</strong></li>
          <ul>
            <li>{t("relationUpdateClickNumber")}</li>
            <li>{t("relationUpdateClickEditBtn")}</li>
          </ul>

          <li className="mt-3"><strong>{t("relationUpdateProspectTitle")}</strong></li>
          <ul>
            <li>{t("relationUpdateProspectUpdateFields")}</li>
            <li>{t("relationUpdateProspectClickSave")}</li>
            <li>{t("relationUpdateProspectSuccessMsg")}</li>
          </ul>

          {/* NL only — Pending client update (Asperion toggle involved) */}
          {finLabels.showAsperionSection && (
            <>
              <li className="mt-3"><strong>{t("relationUpdateClientPendingTitle")}</strong></li>
              <ul>
                <li>{t("relationUpdateClientPendingToggle")}</li>
                <li>{t("relationUpdateClientPendingToggleEnable")}</li>
                <li>{t("relationUpdateClientPendingEditFields")}</li>
                <li>{t("relationUpdateClientPendingClickSave")}</li>
                <li>{t("relationUpdateClientPendingSuccessMsg")}</li>
              </ul>
            </>
          )}

          {/* NL only — Already in Asperion update */}
          {finLabels.showAsperionSection && (
            <>
              <li className="mt-3"><strong>{t("relationUpdateClientFinalTitle")}</strong></li>
              <ul>
                <li>{t("relationUpdateClientToggleDisabled")}</li>
                <li>{t("relationUpdateClientEditFields")}</li>
                <li>{t("relationUpdateClientClickSave")}</li>
                <li>{t("relationUpdateClientConfirmPopup")}
                  <ul>
                    <li>{t("relationUpdateClientPopupCancel")}</li>
                  </ul>
                </li>
                <li>{t("relationUpdateClientFinalSuccessMsg")}</li>
              </ul>
            </>
          )}

          <li className="mt-3"><strong>{t("relationDeleteTitle")}:</strong></li>
          <ul>
            <li>{t("relationDeleteClickNumber")}</li>
            <li>{t("relationDeleteGoToDetails")}</li>
            <li>{t("relationDeleteConfirmPopup")}
              <ul>
                <li>{t("relationDeleteClickCancel")}</li>
                <li>{t("relationDeleteClickDelete")}</li>
              </ul>
            </li>
            <li>{t("relationDeleteSuccessMsg")}</li>
            <li>{t("relationDeleteRemovedFromList")}</li>
          </ul>
        </ul>
      ),
      video: howToCreateRelationVideo,
      thumbnail: howToCreateRelationThumb
    },
    {
      question: t('howToCreateUpdateDeleteUsers'),
      answer: (
        <ul>
          <li><strong>{t('createNewUser')}</strong></li>
          <ul>
            <li>{t('logInToClean2U', { organizationName: orgName })}</li>
            <li>{t('goToUsersMenu')}</li>
            <li>{t('selectBranchToCreateUser')}</li>
            <li>{t('clickNewUserButton')}</li>
            <li>{t('enterRequiredDetails')}</li>
            <li>{t('clickSaveAfterFillingInfo')}</li>
            <li>{t('confirmationMessageUserAdded')}</li>
            <li>{t('newUserAppearsAtTop')}</li>
          </ul>

          <li className="mt-3"><strong>{t('updateExistingUser')}</strong></li>
          <ul>
            <li>{t('clickUserNumberToUpdate')}</li>
            <li>{t('redirectToUserDetailsPage')}</li>
            <li>{t('clickEditButton')}</li>
            <li>{t('updateFieldsAsNeeded')}</li>
            <li>{t('roleGrantsAccessToProject', { organizationName: orgName })}</li>
            <li>{t('accessInfoShownAfterSaving')}</li>
            <li>{t('noteOnUpdatingStatus')}:</li>
            <ul>
              <li>{t('activeStatusAllowsLogin', { organizationName: orgName })}</li>
              <li>{t('inactiveStatusPreventsLogin', { organizationName: orgName })}</li>
            </ul>
            <li>{t('clickSaveToSaveChanges')}</li>
            <li>{t('confirmationMessageUserUpdated')}</li>
            <li>{t('updatedUserAppearsAtTop')}</li>
          </ul>

          <li className="mt-3"><strong>{t('deleteUser')}</strong></li>
          <ul>
            <li>{t('clickUserNumberToDelete')}</li>
            <li>{t('redirectToUserDetailsPage')}</li>
            <li>{t('confirmationPopupMessage')}</li>
            <li>{t('clickCancelToAbortDeletion')}</li>
            <li>{t('clickDeleteToConfirm')}</li>
            <li>{t('confirmationMessageUserDeleted')}</li>
          </ul>
        </ul>

      ),
      video: howToCreateUserVideo,
      thumbnail: howToCreateUserThumb
    }
  ];

  // Filtered list of FAQs based on search term
  const filteredFaqItems = faqItems.filter(item =>
    item.question.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Row className="g-3 mb-3">
        <Col lg={12} xxl={12}>
          <Card className="mb-3 h-100">
            <Background
              image={corner4}
              className="bg-card"
              style={{
                borderTopRightRadius: "0.375rem",
                borderBottomRightRadius: "0.375rem",
              }}
            />
            <Card.Body className="position-relative pe-4 pb-2">
              <Row className="flex-between-center">
                <Col md>
                  <h5 className="mb-2 mb-md-0">{t('frequentlyAskedQuestions')}</h5>
                  <Breadcrumb>
                    <Breadcrumb.Item
                      as={Link}
                      to="/support"
                      className="fw-semi-bold mb-1 fs-9 data-font-colour"
                      active
                    >
                      {t('support')}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className="fw-bold mb-1 fs-9 data-font-colour" active>
                    {t('frequentlyAskedQuestions')}
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Card>
        <Card.Body>
          <Row className="flex-between-center p-2">
            <Col className="ml-auto">
              <InputGroup className="ms-auto text-end ps-0">
                <FormControl
                  size="md"
                  id="search"
                  type="search"
                  className="shadow-none"
                  placeholder={t("searchLabel")}
                  onChange={e => setSearchTerm(e.target.value)}
                />
                <Button
                  size="sm"
                  variant="outline-secondary"
                  className="border-300 hover-border-secondary"
                >
                  <FontAwesomeIcon icon="search" className="fs--1" />
                </Button>
              </InputGroup>
            </Col>
          </Row>

          <Accordion alwaysOpen>
            {filteredFaqItems.map((item, index) => (
              <Accordion.Item eventKey={index.toString()} key={index}>
                <Accordion.Header>
                  <div className="d-flex">
                    <FontAwesomeIcon
                      icon="caret-right"
                      className="accordion-icon me-3 mt-1"
                      transform="shrink-2"
                    />
                    <span className="fw-medium font-sans-serif text-900">
                      {item.question}
                    </span>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col md={7} className="ps-3 data-font-size data-font-colour">
                      {item.answer}
                    </Col>
                    <Col md={5}>
                      <div className="video-wrapper" style={{ borderRadius: "0.5rem", overflow: "hidden" }}>
                        <ReactPlayer
                          url={item.video}
                          light={item.thumbnail}
                          controls
                          playing={currentlyPlayingIndex === index}
                          onPlay={() => setCurrentlyPlayingIndex(index)}
                          width="100%"
                        />
                      </div>
                    </Col>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Card.Body>
      </Card>
    </>
  );
};

export default Faq;